import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react';

interface NotInWhiteListUsersContextType {
  includeNotInWhiteListUsers: boolean;
  setIncludeNotInWhiteListUsers: (value: boolean) => void;
}

const NotInWhiteListUsersContext = createContext<
  NotInWhiteListUsersContextType | undefined
>(undefined);

export const NotInWhiteListUsersProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [includeNotInWhiteListUsers, setIncludeNotInWhiteListUsers] =
    useState<boolean>(false);

  return (
    <NotInWhiteListUsersContext.Provider
      value={{ includeNotInWhiteListUsers, setIncludeNotInWhiteListUsers }}
    >
      {children}
    </NotInWhiteListUsersContext.Provider>
  );
};

export const useNotInWhiteListUsers = (): NotInWhiteListUsersContextType => {
  const context = useContext(NotInWhiteListUsersContext);
  if (context === undefined) {
    throw new Error(
      'useNotInWhiteListUsers must be used within a NotInWhiteListUsersProvider',
    );
  }
  return context;
};
